module.exports = __webpack_public_path__ + "static/media/11.600cae63.jpg";